var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-item mb-4 mb-md-5 pb-3 pb-md-4" },
    [
      _c("router-link", { attrs: { to: _vm.item.router } }, [
        _c("div", { staticClass: "search-item__title mb-1 mb-md-2" }, [
          _c("span", [_vm._v(_vm._s(_vm.item.type))]),
          _vm._v(" |\n            "),
          _c("strong", [_vm._v(_vm._s(_vm.item.title))]),
        ]),
        _vm._v(" "),
        _vm.item.date
          ? _c(
              "time",
              {
                staticClass: "search-item__date d-block mb-2 mb-md-3",
                attrs: { datetime: _vm.timeSI, pubdate: "" },
              },
              [
                _c("span", { staticClass: "far fa-clock" }),
                _vm._v("\n            " + _vm._s(_vm.timeText) + "\n        "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "search-item__match" }, [
          _vm._v(_vm._s(_vm.item.description)),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }